import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Home replaces the Dashboard (HOME-QUESTIONS §1 decision 10). The Dashboard was `/agents` with nothing selected;
 * the agents page itself still hosts agent chats (`?conversationId` / `?select` from the hire wizard). Every old
 * link to the bare `/agents` (the hire wizard's cancel, a released agent's chat, the feature gate) now lands on Home.
 */
export const dashboardToHomeGuard: CanActivateFn = (route) => {
  const params = route.queryParamMap;
  if (params.get('conversationId') || params.get('select')) return true;
  return inject(Router).createUrlTree(['/home']);
};
